<div class="up-images">
  @if (src) {
    <img [src]="src" [alt]="alt" />
  }
</div>
